import React, { FC } from 'react';
import { PageHeader } from 'antd';

export const DirectoryOrganizationsHeader: FC = (): JSX.Element => (
  <PageHeader subTitle="- Organizations" title="Provider Directory" />
);
